import React from 'react'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import exploreOffersImg from '@assets/images/home/explore-offers.png'
import exploreProjectsImg from '@assets/images/home/explore-projects.png'
import resourcesImg from '@assets/images/home/resources.png'
import { LinkButton } from '@communityshare/ui-shared'

const defaultCards = [
  {
    id: 'explore-offers',
    image: exploreOffersImg,
    imageAlt: 'Explore offers from community partners',
    title: 'Explore offers from community partners',
    description: 'Discover learning experiences that partners in your community are offering.',
    ctaLabel: 'View',
  },
  {
    id: 'explore-projects',
    image: exploreProjectsImg,
    imageAlt: 'Explore active projects and events',
    title: 'Explore active projects and events',
    description: 'Browse projects and events from other educators to spark new ideas!',
    ctaLabel: 'View',
  },
  {
    id: 'resources',
    image: resourcesImg,
    imageAlt: 'Find support and resources',
    title: 'Find support and resources',
    description: 'Get in touch with your local support team, find tools to get started, and more!',
    ctaLabel: 'Get support',
  },
]

export default function ExploreCardsHomeScreen(props) {
  const {
    cards = defaultCards,
    onCardClick = (_id) => {},
  } = props;
  return (
    <div className="flex flex-col gap-4 w-full">
      {cards.map(card => (
        <div
          key={card.id}
          className={classNames(
            'bg-white border border-gray-100 rounded-2xl p-4',
            'shadow-[0px_4px_100px_0px] shadow-gray-300/20',
            'transition-all duration-150',
            'lg:hover:border-gray-300 lg:hover:shadow-sm cursor-pointer',
          )}
          onClick={() => onCardClick(card.id)}
        >
          <div className="flex flex-row gap-[14px] items-stretch">
            <div className="w-[120px] md:w-[181px] flex-shrink-0 rounded-[5px] overflow-hidden">
              <img
                src={card.image}
                alt={card.imageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="flex flex-col gap-[4px] flex-1 min-w-0">
              <p className="font-semibold text-lg leading-[1.3] tracking-[0.18px] text-gray-950">
                {card.title}
              </p>
              <p className="font-normal text-sm leading-[1.6] tracking-[0.15px] text-gray-700">
                {card.description}
              </p>
              <div>
                <LinkButton
                  label={card.ctaLabel}
                  onClick={(e) => {
                    e.stopPropagation()
                    onCardClick(card.id)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

ExploreCardsHomeScreen.propTypes = {
  cards: PropTypes.array,
  onCardClick: PropTypes.func,
}
